'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { ExternLogo } from '@extern/ui/logos';
import { Text } from '@extern/ui/text';
import Image from 'next/image';
interface LayoutProps {
  children: ReactNode;
  text: ReactNode;
}
export function AuthLayout(t0) {
  const $ = _c(9);
  const {
    children,
    text
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ExternLogo height={32} width={32} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <div className="flex flex-col items-center justify-center gap-10">{t1}{children}</div>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Image alt="Students picture" height={376} src="/images/login-image.png" width={328} />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== text) {
    t4 = <div className="hidden flex-col items-center justify-center gap-6 rounded-2xl bg-blue-light p-6 md:flex">{t3}<Text className="text-center" data-cy="title" heading="md">{text}</Text></div>;
    $[4] = text;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t4) {
    t5 = <div className="grid min-h-screen w-full grid-cols-1 p-6 md:grid-cols-2">{t2}{t4}</div>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}